var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseAction',[_c('PrimaryButton',{attrs:{"full-width":_vm.isMobile},nativeOn:{"click":function($event){return _vm.openDialog.apply(null, arguments)}}},[_vm._v(" Credit Timesheet ")]),_c('CreditDialog',{attrs:{"isOpen":_vm.isDialogOpen,"id":_vm.id},on:{"close":_vm.closeDialog,"onUpdate":_vm.onUpdate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }